// Console owner insights: dashboard, finance, reports, site content.
// Keys are the Arabic source strings (what the Arabic UI shows); values are English.
// Strings that already exist in the prototype catalog (en.ts) need no entry here.
export const consoleInsightsEn: Readonly<Record<string, string>> = {
  // Dashboard
  'صباح الخير': 'Good morning',
  'مساء الخير': 'Good evening',
  'آخر تحديث {time}': 'Updated {time}',
  'تخصيص اللوحة': 'Customize',
  'التخطيط الافتراضي': 'Default layout',
  'إضافة عنصر': 'Add widget',
  تم: 'Done',
  'اسحب العناصر لإعادة ترتيبها، وغيّر حجمها أو احذفها. يُحفظ التخطيط تلقائياً.':
    'Drag widgets to reorder them, resize or remove them. The layout saves automatically.',
  'جارٍ الحفظ…': 'Saving…',
  'كل التغييرات محفوظة': 'All changes saved',
  'تم حفظ تخطيط اللوحة': 'Dashboard layout saved',
  'عاد التخطيط الافتراضي': 'Default layout restored',
  'أضيف العنصر': 'Widget added',
  'لوحتك فارغة. أضف ما تريد رؤيته كل يوم.': 'Your dashboard is empty. Add what you want to see every day.',
  'لا توجد عناصر متاحة لدورك.': 'No widgets are available to your role.',
  'اختر ما تريد رؤيته كل يوم في لوحتك.': 'Choose what you want to see on your dashboard every day.',
  مضاف: 'Added',
  'تغيير الحجم': 'Change size',
  'الحجم {size}. تغيير الحجم: {name}': 'Size {size}. Change the size of {name}',
  'للخلف: {name}': 'Move back: {name}',
  'للأمام: {name}': 'Move forward: {name}',
  'حذف: {name}': 'Remove: {name}',
  'اسحب لتغيير الترتيب: {name}': 'Drag to reorder: {name}',
  'اسحب لتغيير الترتيب': 'Drag to reorder',
  'التقطت {name}، في الموضع {pos} من {n}.': 'Picked up {name}, at position {pos} of {n}.',
  '{name} الآن فوق الموضع {pos} من {n}.': '{name} is now over position {pos} of {n}.',
  '{name} خارج اللوحة.': '{name} is outside the dashboard.',
  'أُفلت {name} في الموضع {pos} من {n}.': '{name} dropped at position {pos} of {n}.',
  'أُفلت {name}.': '{name} dropped.',
  'أُلغي السحب. عاد {name} إلى مكانه.': 'Drag cancelled. {name} went back to its place.',
  'لتحريك العنصر اضغط مسافة أو Enter، ثم الأسهم لتغيير مكانه، ثم مسافة أو Enter للإفلات، أو Escape للإلغاء.':
    'To move a widget, press Space or Enter, use the arrow keys to move it, then Space or Enter to drop it, or Escape to cancel.',
  'هذا العنصر غير متاح لدورك': 'This widget is not available to your role',
  'هذا العنصر لم يعد متوفراً': 'This widget is no longer available',
  'تعذّر تحميل هذا العنصر. سيُعاد المحاولة تلقائياً.':
    'This widget could not load. It will retry on its own.',
  'المبالغ مخفية لدورك': 'Amounts are hidden for your role',
  'عن أمس': 'vs yesterday',
  'عن الأسبوع الماضي': 'vs last week',
  'عن الشهر الماضي': 'vs last month',
  '{n} تسليم': '{n} handovers',
  '{n} استلام': '{n} returns',
  '{n} متأخرة': '{n} overdue',
  'لا تسليمات متبقية': 'No pickups left',
  'إشغال الأسطول': 'Fleet utilization',
  'آخر 7 أيام': 'Last 7 days',
  '{n} ساعة مؤجرة من {m}': '{n} of {m} hours rented',
  'الإضافات والرسوم': 'Extras and fees',
  'الإيرادات · آخر 14 يوماً': 'Revenue · last 14 days',
  'لا مواعيد اليوم': 'Nothing scheduled today',
  'حالة الأسطول': 'Fleet status',
  'لا توجد سيارات': 'No cars',
  'بطارية منخفضة': 'Low battery',
  مفتوح: 'Open',
  بحذر: 'Caution',
  مغلق: 'Closed',
  تعمل: 'Open',
  مغلقة: 'Closed',
  'الطقس غير متاح الآن': 'Weather unavailable right now',
  الطريق: 'Road',
  الغروب: 'Sunset',
  'آخر قراءة {time}': 'Last reading {time}',
  'لا إضافات هذا الشهر': 'No extras this month',
  'أكثر الإضافات طلباً': 'Most popular extras',
  'لا حجوزات هذا الشهر بعد': 'No bookings this month yet',
  '{n} حجزاً هذا الشهر': '{n} bookings this month',
  'الحجوزات الأونلاين زادت {n}% عن الشهر الماضي': 'Online bookings up {n}% on last month',
  'الحجوزات الأونلاين قلّت {n}% عن الشهر الماضي': 'Online bookings down {n}% on last month',
  'أوقات الذروة': 'Peak times',
  '{n} استلامات': '{n} pickups',
  'لا طلبات معلقة': 'No pending requests',
  'بانتظار الاعتماد': 'Awaiting approval',
  'مراجعة الطلبات': 'Review requests',
  'لا تنبيهات': 'No alerts',
  'متأخر {n} كم': 'Overdue by {n} km',
  'بعد {n} كم': 'In {n} km',
  إطارات: 'Tyres',
  فحص: 'Inspection',
  'لا أنشطة بعد': 'No activity yet',
  النظام: 'System',
  // Activity lines
  'أنشأ الحجز {label}': 'created booking {label}',
  'أُكّد الحجز {label}': 'booking {label} confirmed',
  'ألغى الحجز {label}': 'cancelled booking {label}',
  'حوّل الحجز {label} إلى رصيد': 'converted booking {label} to credit',
  'انتهت مهلة الدفع للحجز {label}': 'payment time ran out for booking {label}',
  'سلّم السيارة في الحجز {label}': 'handed over the car for booking {label}',
  'استلم السيارة في الحجز {label}': 'received the car back for booking {label}',
  'عدّل موعد الحجز {label}': 'changed the schedule of booking {label}',
  'غيّر سيارة الحجز {label}': 'changed the car of booking {label}',
  'سجّل عدم حضور في الحجز {label}': 'recorded a no-show for booking {label}',
  'سجّل دفعة في الحجز {label}': 'recorded a payment for booking {label}',
  'وصلت دفعة الحجز {label}': 'payment received for booking {label}',
  'استرجع مبلغاً في الحجز {label}': 'refunded an amount on booking {label}',
  'طلب استرجاع مبلغ في الحجز {label}': 'requested a refund on booking {label}',
  'تعذّر الدفع في الحجز {label}': 'payment failed for booking {label}',
  'طلب تحويل الحجز {label} إلى رصيد': 'asked to convert booking {label} to credit',
  'اعتمد طلب الرصيد {label}': 'approved the credit request {label}',
  'رفض طلب الرصيد {label}': 'declined the credit request {label}',
  'أضاف رصيداً {label}': 'added credit {label}',
  'عدّل نصاً في الموقع': 'edited a text on the website',
  'غيّر ظهور قسم في الموقع': 'changed the visibility of a website section',
  'خصّص لوحة اليوم': 'customized the dashboard',
  'سجّل الدخول': 'signed in',
  'سجّل الخروج': 'signed out',
  'أضاف مصروفاً {label}': 'added an expense {label}',
  'عدّل مصروفاً {label}': 'edited an expense {label}',
  'ألغى مصروفاً {label}': 'voided an expense {label}',
  'عدّل الأسعار': 'changed prices',
  'عدّل الأسطول والإضافات': 'changed the fleet and extras',
  'حدّث حالة السيارة {label}': 'updated car {label}',
  'عدّل بيانات الفريق': 'changed team details',
  'عدّل الأدوار والصلاحيات': 'changed roles and permissions',
  'عدّل الإعدادات': 'changed settings',
  'حدّث بيانات الزبون {label}': 'updated customer {label}',
  'عدّل الحجز {label}': 'changed booking {label}',
  'حدّث مدفوعات الحجز {label}': 'updated payments of booking {label}',
  'حدّث الأرصدة {label}': 'updated credit {label}',
  'أرسل إشعاراً {label}': 'sent a notification {label}',
  'حدّث حالة الطريق': 'updated the road status',
  'نفّذ إجراءً {label}': 'made a change {label}',

  // Finance
  'الفترة السابقة': 'Previous period',
  'الفترة التالية': 'Next period',
  'حتى الآن': 'to date',
  'لا إيرادات في الفترة السابقة': 'No revenue in the previous period',
  'إضافات ورسوم': 'extras and fees',
  'تأخير ورسوم': 'Late and fees',
  خصومات: 'Discounts',
  'بعد خصم المصاريف': 'After expenses',
  'الخدمات الإضافية والرسوم': 'Extras and fees',
  'المصاريف المسجلة لهذا الشهر.': 'Expenses recorded for this month.',
  'المصاريف الشهرية محسوبة بنسبة الفترة.': 'Monthly expenses are prorated to the period.',
  'لا مصاريف في هذه الفترة. أضفها من قائمة المصاريف أدناه.':
    'No expenses in this period. Add them in the expenses list below.',
  مسترجع: 'Refunded',
  'لا إضافات في هذه الفترة': 'No extras in this period',
  'أداء السيارات في الفترة': 'Car performance in the period',
  'لا حجوزات في هذه الفترة': 'No bookings in this period',
  المصاريف: 'Expenses',
  'إظهار الملغاة': 'Show voided',
  'لا مصاريف مسجلة بعد': 'No expenses recorded yet',
  'شهرياً من {from} إلى {to}': 'Monthly from {from} to {to}',
  'شهرياً منذ {from}': 'Monthly since {from}',
  'تعديل {label}': 'Edit {label}',
  'إلغاء {label}': 'Void {label}',
  'إضافة مصروف': 'Add expense',
  'تعديل مصروف': 'Edit expense',
  'المصاريف الشهرية تُوزّع على الأيام عند حساب الصافي.':
    'Monthly expenses are spread over the days when the net is worked out.',
  إلغاء: 'Cancel',
  'حفظ التغييرات': 'Save changes',
  'إضافة المصروف': 'Add expense',
  'أضيف المصروف': 'Expense added',
  'تم حفظ المصروف': 'Expense saved',
  الوصف: 'Description',
  'المبلغ الشهري (ر.ع)': 'Monthly amount (OMR)',
  'المبلغ (ر.ع)': 'Amount (OMR)',
  'من شهر': 'From month',
  الشهر: 'Month',
  'حتى شهر (اختياري)': 'Until month (optional)',
  'اتركه فارغاً إن كان مستمراً': 'Leave empty if it keeps going',
  'يتكرر كل شهر': 'Repeats every month',
  'أُلغي المصروف': 'Expense voided',
  'إلغاء المصروف «{label}»؟': 'Void the expense “{label}”?',
  'إلغاء المصروف': 'Void expense',
  'يبقى ظاهراً في القائمة ولا يُحسب في المصاريف. لا يمكن التراجع عن الإلغاء.':
    'It stays in the list and no longer counts as an expense. Voiding cannot be undone.',
  'اكتب سبب الإلغاء': 'Write the reason',
  إيجار: 'Rent',
  رواتب: 'Salaries',
  كهرباء: 'Electricity',
  'شحن السيارات': 'Car charging',
  صيانة: 'Maintenance',
  تسويق: 'Marketing',
  أخرى: 'Other',
  'اكتب وصف المصروف': 'Describe the expense',
  'الوصف طويل جداً': 'The description is too long',
  'اكتب مبلغاً صحيحاً أكبر من صفر': 'Enter a valid amount above zero',
  'اختر الشهر': 'Choose the month',
  'آخر شهر قبل شهر البداية': 'The last month is before the first month',

  // Reports
  'و{n} ملغاة أو محوّلة': 'and {n} cancelled or converted',
  'تصدير Excel': 'Export Excel',
  طباعة: 'Print',
  'فترات جاهزة': 'Quick ranges',
  'نوع التقرير': 'Report type',
  التحصيل: 'Collections',
  'جارٍ تجهيز ملف {format}…': 'Preparing the {format} file…',
  'الملف جاهز': 'File ready',
  '{n} صف': '{n} rows',
  'تنزيل مرة أخرى': 'Download again',
  'انتهت صلاحية الملف': 'The file has expired',
  'تعذّر تجهيز الملف': 'The file could not be prepared',
  'تم تنزيل الملف': 'File downloaded',
  تقرير: 'Report',
  'أُنشئ في': 'Generated on',

  // Site content
  'عدّل نصوص الموقع وشاهد النتيجة كما يراها الزائر': 'Edit the website text and see it the way visitors do',
  'محرر الموقع': 'Site editor',
  'عدّل نصوص الموقع وشاهدها كما يراها الزائر': 'Edit the website text and see it as visitors do',
  'اختر القسم وعدّل أي عنوان أو نص أو زر': 'Pick a section and edit any heading, text or button',
  'أخفِ أو أظهر أي قسم بضغطة': 'Hide or show any section with one tap',
  'العربية والإنجليزية جنباً إلى جنب': 'Arabic and English side by side',
  'يُحفظ تلقائياً ويظهر للزوار فوراً': 'Saves automatically and goes live right away',
  'ابدأ التحرير': 'Start editing',
  'إنهاء التحرير': 'Finish editing',
  '{n} نصوص معدّلة': '{n} texts edited',
  '{n} أقسام مخفية': '{n} sections hidden',
  '{n} معدّل': '{n} edited',
  'كل النصوص أصلية': 'All texts are original',
  دائم: 'Always shown',
  'آخر تعديلات المحتوى': 'Latest content changes',
  'استرجاع كل النصوص الأصلية': 'Restore all original texts',
  'استرجاع كل النصوص الأصلية؟': 'Restore all original texts?',
  'استرجاع الكل': 'Restore all',
  'تعود {n} نصوص إلى نصها الأصلي بالعربية والإنجليزية. يبقى كل تعديل في السجل ويمكن استرجاعه.':
    '{n} texts go back to their original Arabic and English. Every edit stays in the history and can be restored.',
  'عدّل نص «{name}» ({lang})': 'edited “{name}” ({lang})',
  'استرجع النص الأصلي: {name} ({lang})': 'restored the original text: {name} ({lang})',
  'لم يُعدَّل أي نص بعد': 'No text has been edited yet',
  عربي: 'Arabic',
  مشترك: 'Shared',
  'تعذّر تغيير ظهور القسم «{name}»': 'Could not change the visibility of “{name}”',
  'ظهر القسم في الموقع': 'The section is now shown on the site',
  'أُخفي القسم من الموقع': 'The section is now hidden from the site',
  'لا توجد أقسام': 'No sections',
  'ظاهر للزوار': 'Shown to visitors',
  'مخفي عن الزوار': 'Hidden from visitors',
  'اترك النص كما هو أو امسحه ليعود النص الأصلي. يُحفظ كل تعديل ويظهر للزوار فوراً.':
    'Clear a text to bring back the original. Every edit saves and goes live right away.',
  'لم يُحفظ تعديل، راجع الحقل': 'An edit was not saved, check the field',
  'معاينة الموقع': 'Site preview',
  'معاينة الصفحة الرئيسية': 'Homepage preview',
  'لغة المعاينة': 'Preview language',
  'حجم الشاشة': 'Screen size',
  كمبيوتر: 'Desktop',
  جوال: 'Phone',
  'تحديث المعاينة': 'Reload preview',
  'فتح الموقع في نافذة جديدة': 'Open the site in a new window',
  'إظهار القسم': 'Show section',
  'عدّل شخص آخر هذا النص للتو، فحمّلنا آخر نسخة. راجعها ثم عدّل من جديد.':
    'Someone else just edited this text, so the latest version is loaded. Check it and edit again.',
  محفوظ: 'Saved',
  'سجل التعديلات': 'Edit history',
  'سجل التعديلات: {name}': 'Edit history: {name}',
  السجل: 'History',
  'استرجاع الأصل': 'Restore original',
  'يمكن استخدام <b> للخط العريض و<i> للمائل.': 'You can use <b> for bold and <i> for italics.',
  'رابط كامل يبدأ بـ https://': 'A full link starting with https://',
  'تعذّر استرجاع النص الأصلي. حاول مرة أخرى.': 'Could not restore the original text. Try again.',
  تعديل: 'Edit',
  'استرجاع نسخة': 'Restored version',
  اللغة: 'Language',
  'لم يُعدَّل هذا النص بعد': 'This text has not been edited yet',
  الحالي: 'Current',
  'النص الأصلي': 'Original text',
  'استُرجع النص': 'Text restored',
  'استرجاع هذه النسخة': 'Restore this version',
  تراجع: 'Back',
  // Review fixes
  'جارٍ التحميل…': 'Loading…',
  'عدّل شخص آخر هذا المصروف للتو. حمّلنا النسخة الحالية، راجع القيم ثم احفظ مرة أخرى.':
    'Someone else changed this expense just now. We loaded the current version; check the values and save again.',
  التقارير: 'Reports',
  'كل الفواتير والإيصالات والإشعارات الدائنة': 'Every invoice, receipt and credit note',
};
